module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/man-mobile_4347a9.png";